var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_974102_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58173 16 0 12.4183 0 8C0 3.58173 3.58173 0 8 0C12.4183 0 16 3.58173 16 8ZM11.6431 4.35689C11.3641 4.07795 10.9119 4.07795 10.6329 4.35689L4.35688 10.6329C4.07793 10.9119 4.07793 11.3642 4.35688 11.6431C4.63583 11.9221 5.08809 11.9221 5.36703 11.6431L11.6431 5.36705C11.9221 5.0881 11.9221 4.63584 11.6431 4.35689ZM5.48957 4.14769C4.74846 4.14769 4.14767 4.74847 4.14767 5.48958C4.14767 6.23069 4.74846 6.83147 5.48957 6.83147C6.23066 6.83147 6.83145 6.23069 6.83145 5.48958C6.83145 4.74847 6.23066 4.14769 5.48957 4.14769ZM10.5104 9.16853C9.76931 9.16853 9.16853 9.76931 9.16853 10.5104C9.16853 11.2515 9.76931 11.8523 10.5104 11.8523C11.2515 11.8523 11.8523 11.2515 11.8523 10.5104C11.8523 9.76931 11.2515 9.16853 10.5104 9.16853Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_974102_1531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIconWhite);
export default __webpack_public_path__ + "static/media/percent-icon-white.c14e8194e6be9bc4388468bc0721583f.svg";
export { ForwardRef as ReactComponent };